import React from 'react';
import { Button, Icon, SpaceBetween } from '@amzn/awsui-components-react';
import { Privileges } from 'src/utils/UserSitesUtils';
import { debug } from 'src/utils/commonUtils';

function ModeButtonBar(props: any) {
  debug(`ModeButtonBar() props is ${JSON.stringify(props)}`);

  const refresh = () => {
    props.refreshDevicesCallback();
  };

  return (
    <SpaceBetween size="xs" direction="horizontal">
      <Button
        disabled=
          {
            (!props.userSitePrivs?.includes(Privileges.all) ||
            props.selectedItemsLength === 0)
          }
        onClick= { () => props.setChangeModeVisibleCallback(true) }
        variant='primary'
      >
        Change Mode ({props.selectedItemsLength})
      </Button>
      <Button onClick={() => props.selectDeselectAllCallBack()} disabled={props.selectDeselectAllDisabled}>
        {props.selectDeselectAllButtonLabel}
      </Button>
      <Button onClick={refresh} ariaLabel='refresh readers'>
        <Icon name='refresh' alt='refresh readers'/>
      </Button>
    </SpaceBetween>
  );
}

export default ModeButtonBar;
